import { render, staticRenderFns } from "./punishList.vue?vue&type=template&id=23f3cb76&scoped=true&"
import script from "./punishList.vue?vue&type=script&lang=js&"
export * from "./punishList.vue?vue&type=script&lang=js&"
import style0 from "./punishList.vue?vue&type=style&index=0&id=23f3cb76&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f3cb76",
  null
  
)

export default component.exports